import * as types from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'
import formatedFilters from '@helpers/formatAxiosGetFilters'

const state = {
  engagement_order: null,
  engagement_orders: [],
  paginate: {}
}

const getters = {
  [types.ENGAGEMENT_ORDER]: 'engagement_order',
  [types.ENGAGEMENT_ORDERS]: 'engagement_orders',
  [types.ENGAGEMENT_ORDERS_PAGINATE]: 'paginate'
}

const mutations = {
  [types.ENGAGEMENT_ORDER]: 'engagement_order',
  [types.ENGAGEMENT_ORDERS]: 'engagement_orders',
  [types.ENGAGEMENT_ORDERS_PAGINATE]: 'paginate'
}

const actions = {
  [types.ENGAGEMENT_ORDER]: async ({ commit, dispatch }, orderId) => {
    try {
      const response = await axios.get(`engagements/${orderId}`)
      const engagement_order = response.data?.data || {}

      commit(types.ENGAGEMENT_ORDER, engagement_order || {})
      return true
    } catch (error) {
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro ao carregar o pedido!'
      })
      throw new Error('Ocorreu um erro ao carregar o pedido!')
    }
  },

  [types.ENGAGEMENT_ORDERS]: async ({ commit, dispatch }, params = '') => {
    const filters = formatedFilters(params)

    try {
      const response = await axios.get(`engagements?${filters}`)
      const engagement_orders = response.data?.data || {}
      const pagination = response.data?.meta || {}

      commit(types.ENGAGEMENT_ORDERS, engagement_orders || [])
      commit(types.ENGAGEMENT_ORDERS_PAGINATE, pagination || {})
      return true
    } catch (error) {
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro ao carregar os pedidos!'
      })
      throw new Error('Ocorreu um erro ao carregar o pedido!')
    }
  },

  [types.ENGAGEMENT_ORDER_UPDATE]: async ({ dispatch }, payload) => {
    try {
      await axios.patch('engagements', payload)
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Status do(s) pedido(s) de pontos alterado(s) com sucesso!'
      })
      return true
    } catch (error) {
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro!'
      })
      throw new Error('Ocorreu um erro ao alterar o status do pedido!')
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/engagement.js